import Icon from '../components/Icon.vue'

Icon.register({
  'solar-panel': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M432 448c8.8 0 16 7.2 16 16l0 31.7c0 8.8-7.2 16-16 16l-224 0.3c-8.8 0-16-7.2-16-16l0-31.7c0-8.8 7.2-16 16-16l48 0v-32.2h128v32.1zM585.2 26.7c58.1 342.4 54.8 321.4 54.8 325.5-0.1 17.2-14.4 31.8-32.6 31.8h-574.7c-18.3 0-32.6-14.7-32.6-32 0-3.9-3.4 17.2 54.8-325.3 2.6-15.4 16.2-26.7 32.1-26.7h466.1c15.9 0 29.5 11.3 32.1 26.7zM259.8 64l-9.8 96h139.9l-9.8-96h-120.3zM184.7 320l11.4-112h-106l-19 112h113.6zM200.9 160l9.8-96h-96.2l-16.3 96h102.7zM233.8 320h172.4l-11.4-112h-149.7zM429.3 64l9.8 96h102.7l-16.3-96h-96.2zM455.3 320h113.6l-19-112h-106z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/solar-panel.js
// module id = 1917
// module chunks = 0